import React from "react";
import { Link } from "react-router-dom";
import {
  FiArrowUp,
  FiCheckCircle,
  FiHeadphones,
  FiMail,
  FiPackage,
  FiTruck,
} from "react-icons/fi";
import "../css/footer.scss";

const serviceItems = [
  {
    icon: FiTruck,
    title: "Tracked Shipping",
    text: "Flat $9.99 delivery fee",
  },
  {
    icon: FiPackage,
    title: "Carefully Packed",
    text: "Fresh ingredients, shipped with care",
  },
  {
    icon: FiCheckCircle,
    title: "Spicy Satisfaction",
    text: "Quality you can count on",
  },
  {
    icon: FiHeadphones,
    title: "Here to Help",
    text: "Friendly, knowledgeable support",
  },
];

const productLinks = [
  "Spices",
  "Herbs",
  "Seasonings",
  "Dried Chiles",
  "Mushrooms",
  "Sea Salts",
  "Peppercorns",
  "Loose Leaf Teas",
];

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <section
        className="site-footer__services"
        aria-label="Our service promises"
      >
        <div className="site-footer__container site-footer__service-grid">
          {serviceItems.map(({ icon: Icon, title, text }) => (
            <div className="site-footer__service" key={title}>
              <Icon aria-hidden="true" />
              <div>
                <strong>{title}</strong>
                <span>{text}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="site-footer__main">
        <div className="site-footer__container site-footer__grid">
          <section
            className="site-footer__about"
            aria-labelledby="footer-about-title"
          >
            <h2 id="footer-about-title">About sickzuno</h2>
            <p>
              We bring hard-to-find spices, herbs and culinary ingredients from
              around the world straight to curious home cooks and professionals.
            </p>
            <a
              className="site-footer__phone"
              href="mailto:harv@sickzuno.online"
            >
              <FiMail aria-hidden="true" />
              <span>
                <small>Questions? Email us</small>
                <strong>harv@sickzuno.online</strong>
              </span>
            </a>
            <address className="site-footer__address">
              Av. del Calvario 13, Tetexcala, 55886 Tepexpan, Méx., MX
            </address>
            <div className="site-footer__about-links">
              <Link to="/about" onClick={toTop}>
                About Us
              </Link>
              <Link to="/contact" onClick={toTop}>
                Contact Us
              </Link>
            </div>
          </section>

          <nav
            className="site-footer__column"
            aria-labelledby="footer-products-title"
          >
            <h2 id="footer-products-title">Products</h2>
            <ul>
              {productLinks.map((label) => (
                <li key={label}>
                  <Link
                    to={`/shop?category=${label
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                    onClick={toTop}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav
            className="site-footer__column"
            aria-labelledby="footer-help-title"
          >
            <h2 id="footer-help-title">Customer Service</h2>
            <ul>
              <li>
                <Link to="/shipping" onClick={toTop}>
                  Shipping &amp; Delivery
                </Link>
              </li>
              <li>
                <Link to="/returns" onClick={toTop}>
                  Returns &amp; Replacements
                </Link>
              </li>
              <li>
                <Link to="/faqs" onClick={toTop}>
                  Frequently Asked Questions
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Track My Order
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={toTop}>
                  Our Guarantee
                </Link>
              </li>
            </ul>
          </nav>

          <section
            className="site-footer__newsletter"
            aria-labelledby="footer-policies-title"
          >
            <h2 id="footer-policies-title">Policies &amp; Help</h2>
            <p>
              Review shopping information, privacy choices and answers to common
              questions.
            </p>
            <div className="site-footer__about-links">
              <Link to="/faqs" onClick={toTop}>
                FAQs
              </Link>
              <Link to="/privacy" onClick={toTop}>
                Privacy Policy
              </Link>
              <Link to="/cookies" onClick={toTop}>
                Cookie Policy
              </Link>
              <Link to="/terms" onClick={toTop}>
                Terms &amp; Conditions
              </Link>
            </div>
          </section>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="site-footer__container site-footer__bottom-inner">
          <p>
            &copy; {new Date().getFullYear()} sickzuno &middot; Rockford,
            Michigan
          </p>
          <div className="site-footer__legal">
            <Link to="/terms" onClick={toTop}>
              Terms of Use
            </Link>
            <Link to="/privacy" onClick={toTop}>
              Privacy Policy
            </Link>
            <Link to="/cookies" onClick={toTop}>
              Cookie Policy
            </Link>
          </div>
          <div
            className="site-footer__payments"
            aria-label="Accepted payment methods"
          >
            <span>VISA</span>
            <span>Mastercard</span>
            <span>AMEX</span>
            <span>Discover</span>
          </div>
        </div>
      </div>

      <button
        className="site-footer__to-top"
        type="button"
        onClick={toTop}
        aria-label="Back to top"
      >
        <FiArrowUp aria-hidden="true" />
      </button>
    </footer>
  );
}

export default Footer;
